import React from 'react'
import styled from 'styled-components'
import Modal from 'components/atoms/Modal'
import { RAG } from 'features/dashboard/charts/scoreColour'

export const removeAccessCopy = (count, everyone) => (everyone
  ? { title: 'Remove access for everyone?', body: 'Nobody except Admins will be able to open this document.' }
  : { title: `Remove access for ${count} ${count === 1 ? 'person' : 'people'}?`, body: 'They will no longer be able to open this document.' })

const RemoveAccessConfirm = ({ open, count, everyone, busy, onConfirm, onCancel }) => {
  const copy = removeAccessCopy(count, everyone)
  return (
    <Modal open={open} title={copy.title} onClose={busy ? undefined : onCancel} minWidthDesktop='360px' maxWidthDesktop='480px'>
      <Body>
        <Text>{copy.body}</Text>
        <Actions>
          <GoBack type='button' disabled={busy} onClick={onCancel}>Go back</GoBack>
          <Remove type='button' disabled={busy} onClick={onConfirm}>{busy ? 'Removing…' : 'Remove access'}</Remove>
        </Actions>
      </Body>
    </Modal>
  )
}

export default RemoveAccessConfirm

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const Text = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
`

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 12px;
`

const Button = styled.button`
  min-height: 44px;
  padding: 0 18px;
  border-radius: 8px;
  font: inherit;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  &:disabled { opacity: 0.6; cursor: default; }
`

const GoBack = styled(Button)`
  border: 1px solid #d4d4d8;
  background: #fff;
  color: #1f2937;
`

const Remove = styled(Button)`
  border: 1px solid ${RAG.critical.fg};
  background: ${RAG.critical.fg};
  color: #fff;
`
